import React from 'react';
import I18n from 'i18n-js';
import { RCButton, RCListingGrid, RCTextWithIcon } from '@reverbdotcom/cadence/components';
import RQLFacets from '@reverbdotcom/commons/src/components/rql_facets';
import { I18N } from '@reverbdotcom/commons/src/components/translate';
import { Filter } from '@reverbdotcom/commons/src/components/search_filters';
import { TimesCircleAltIcon } from '@reverbdotcom/cadence/icons/react';

interface ISidebarFooterProps {
  clearFiltersDisabled: boolean;
  listingSearchTotal: number;
  clearFilters: () => void;
  closeSidebarFilters: () => void;
}

interface ISidebarHeaderProps {
  closeSidebarFilters : () => void;
}

interface ISideBarProps {
  loading: boolean;
  clearFiltersDisabled: boolean;
  listingSearchTotal: number;
  exposedSidebarOpen: boolean;
  useExposedSidebar: boolean;
  trackingQuery?: string;
  filters: Filter[];
  children: React.ReactNode;
  closeSidebarFilters: () => void;
  clearFilters: () => void;
}


const MarketplaceSidebarHeader = ({ closeSidebarFilters }: ISidebarHeaderProps)=> (
  <div className="d-flex fx-justify-between fx-align-center">
    <I18N text="commons.marketplaceFilters.filterAndSort" className="weight-bold" />
    <button
      onClick={closeSidebarFilters}
      type="button"
      className="button-as-link color-primary weight-bold"
    >
      <RCTextWithIcon
        svgComponent={TimesCircleAltIcon}
        size="large"
      >
        {I18n.t('commons.dismissibleSidebar.close')}
      </RCTextWithIcon>
    </button>
  </div>
);

const MarketplaceSidebarFooter = ({
  clearFilters,
  clearFiltersDisabled,
  listingSearchTotal,
  closeSidebarFilters,
} : ISidebarFooterProps) =>{
  return (
    <div className="d-flex fx-justify-between fx-align-center">
      <button
        type="button"
        className="button-as-link color-primary weight-bold"
        onClick={clearFilters}
        disabled={!clearFiltersDisabled}
      >
        <I18N text="commons.marketplaceFilters.clearFilters" />
      </button>
      {listingSearchTotal && (
        <RCButton variant="primary" onClick={closeSidebarFilters}>
          <I18N
            text="commons.marketplaceFilters.showResultsCount"
            args={{ count: I18n.toNumber(listingSearchTotal, { precision: 0 }) }}
          />
        </RCButton>
      )}
    </div>
  );
};

export function MarketplaceGridWithSidebar({
  loading,
  filters,
  children,
  exposedSidebarOpen,
  useExposedSidebar,
  closeSidebarFilters,
  listingSearchTotal,
  trackingQuery = '',
  clearFiltersDisabled,
  clearFilters,
}: ISideBarProps) {
  return (
    <RCListingGrid
      loading={loading}
      sidebarOpen={exposedSidebarOpen}
      sidebar={useExposedSidebar &&
        <RCListingGrid.Sidebar>
          <RCListingGrid.SidebarHeader>
            <MarketplaceSidebarHeader closeSidebarFilters={closeSidebarFilters} />
          </RCListingGrid.SidebarHeader>
          <RCListingGrid.SidebarContent>
            <RQLFacets
              filters={filters}
              loading={loading}
              trackingQuery={trackingQuery}
              inRCListingGrid
            />
          </RCListingGrid.SidebarContent>
          <RCListingGrid.SidebarFooter>
            <MarketplaceSidebarFooter
              clearFilters={clearFilters}
              clearFiltersDisabled={clearFiltersDisabled}
              closeSidebarFilters={closeSidebarFilters}
              listingSearchTotal={listingSearchTotal}
            />
          </RCListingGrid.SidebarFooter>
        </RCListingGrid.Sidebar>
      }
    >
      {children}
    </RCListingGrid>
  );
}

export default MarketplaceGridWithSidebar;
